import client from '@/http'

const startLoading = (context) => {
  context.commit('SET_LOADING', true)
}

const stopLoading = (context) => {
  context.commit('SET_LOADING', false)
}

const handleError = (context, payload) => {
  context.commit('SET_ERROR', payload)
}

const dismissError = (context) => {
  context.commit('DISMISS_ERROR')
}

const getMaintenanceStatus = (context) => {
  client.get(
    '/maintenance'
  ).then(
    (res) => {
      context.commit('SET_MAINTENANCE_STATUS', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

export default {
  stopLoading,
  handleError,
  startLoading,
  dismissError,
  getMaintenanceStatus
}
